class Observer
{
    /**
     *
     * @type {Array}
     */
    Observers = [];

    constructor(observers) {
        if(observers && observers.length && observers.length >0 )
            this.Observers = observers;
    }
    /**
     * updates all registered observers
     * @constructor
     */
    Notify()
    {
        this.Observers.forEach(function (currentElement, /*currentIndex, referenceToArray*/){
            currentElement.Update();
        });
    }
}
export default Observer;